'use client';

import { useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { Toast, useToast } from '@zillow/constellation-10';
import { useFeatureFlag } from '@/src/lib/feature-flags';
import * as styles from './mockBookTourStatus.styles';

export function MockBookTourToast() {
  const t = useTranslations('tourWizard');
  const mockBookTourEnabled = useFeatureFlag('mock-book-tour');
  const { enqueueToast } = useToast();
  const hasEnqueuedRef = useRef(false);

  useEffect(() => {
    if (!mockBookTourEnabled) {
      hasEnqueuedRef.current = false;
      return;
    }

    if (hasEnqueuedRef.current) {
      return;
    }

    hasEnqueuedRef.current = true;
    enqueueToast(
      <Toast tone="info" role="status" data-testid="mock-book-tour-toast">
        <span className={styles.content}>
          <span className={styles.label}>{t('mockBookTourLabel')}</span>
          <span className={styles.message}>{t('mockBookTourActive')}</span>
        </span>
      </Toast>,
      { duration: 0 },
    );
  }, [enqueueToast, mockBookTourEnabled, t]);

  return null;
}
